module.exports = __webpack_public_path__ + "img/status_cancel.3b5fd89b.png";